export default __webpack_public_path__ + "static/media/bg_8.c7981d83.jpg";